import {
  PageHeader,
  Loading,
  toastSuccessMessage,
  updateUserCurrentStep,
} from "wup-module1-base";
import { useNavigate } from "react-router-dom";
import {
  PageTitleConstants,
  ProcessStatusEnum,
  RoutePathConstants,
} from "../../Constants";
import { Card } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import UserContext from "../../Contexts/UserContext";
import { StoreService, CalendarService, AuthService } from "../../Services";
import { WindowOption } from "../../Components";
import { toast } from "react-toastify";

function StoreSummary() {
  const nexSuccessMessage = "Zatwierdzono ofertę";
  const { user, setUser } = useContext(UserContext);
  const [isSubmittinginfo, setIsSubmittingInfo] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const [fundingName, setFundingName] = useState(
    "Dofinansowania w formie bonów"
  );
  const [fundingIcon, setFundingIcon] = useState();

  const [careerName, setCareerName] = useState("Żadnej z usług dodatkowych");
  const [careerIcon, setCareerIcon] = useState();

  const [serviceName, setServiceName] = useState(
    "Kontaktu w sprawie usług Centrum Informacji i Planowania Kariery Zawodowej"
  );
  const [serviceIcon, setServiceIcon] = useState();

  const navigate = useNavigate();

  const storedData = sessionStorage.getItem("storeData");
  const [parsedData, setParsedData] = useState(JSON.parse(storedData));
  const [bookingId, setBooking] = useState(
    parsedData === null ? undefined : parsedData.bookingId
  );
  const [calendarDate, setCalendarDate] = useState();

  const fetchUserData = () => {
    AuthService.getUserData()
      .then((response) => {
        const updatedUser = updateUserCurrentStep(
          user,
          response.data.status,
          response.data.clientStep
        );
        setUser(updatedUser);
      })
      .catch((error) => { });
  };

  useEffect(() => {
    if (!!bookingId) {
      CalendarService.getMeetingDate(bookingId).then((response) => {
        setCalendarDate(response.data);
      });
    }
  }, [bookingId]);

  useEffect(() => {
    StoreService.getOrder(user.id)
      .then((response) => {
        setIsSaved(true);
        setBooking(response.data.meeting_id);
        if (!parsedData) {
          const dataResponse = {
            funding: response.data.funding_item_id,
            offer: response.data.exclusive_item_id,
            service: response.data.service_item_id,
          };
          sessionStorage.setItem("storeData", JSON.stringify(dataResponse));
          setParsedData(dataResponse);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    setIsSubmittingInfo(true);
  }, []);

  useEffect(() => {
    StoreService.storeItems()
      .then((response) => {
        let fundingResponse = response.data.find(
          (item) => item.id === parsedData.funding
        );
        if (fundingResponse !== undefined || fundingResponse != null) {
          setFundingName(fundingResponse.name);
        }

        let fundingOffer = response.data.find(
          (item) => item.id === parsedData.offer
        );
        if (fundingOffer !== undefined || fundingOffer != null) {
          setCareerName(fundingOffer.name);
        }

        let fundingService = response.data.find(
          (item) => item.id === parsedData.service
        );
        if (fundingService !== undefined || fundingService != null) {
          setServiceName(fundingService.name);
        }

        if (fundingResponse?.icon) {
          setFundingIcon(fundingResponse.icon);
        } else {
          let fundingResponseHelper = response.data.find(
            (item) => item.type === 1 && item.icon
          );
          setFundingIcon(fundingResponseHelper?.icon);
        }
        if (fundingOffer?.icon) {
          setCareerIcon(fundingOffer.icon);
        } else {
          let fundingOfferHelper = response.data.find(
            (item) => item.type === 2 && item.icon
          );
          setCareerIcon(fundingOfferHelper?.icon);
        }
        if (fundingService?.icon) {
          setServiceIcon(fundingService.icon);
        } else {
          let fundingServiceHelper = response.data.find(
            (item) => item.type === 3 && item.icon
          );
          setServiceIcon(fundingServiceHelper?.icon);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setIsSubmittingInfo(false);
      });
  }, [parsedData]);

  function goSubmit() {
    setIsSubmitting(true);
    if (parsedData !== null) {
      const dataStore = {
        fundingItemId: parsedData.funding,
        exclusiveItemId:
          !!parsedData.offer && !!parsedData.bookingId
            ? parsedData.offer
            : null,
        bookingId:
          !!parsedData.offer && !!parsedData.bookingId
            ? parseInt(parsedData.bookingId)
            : null,
        serviceItemId: parsedData.service,
      };

      StoreService.storeOrder(user.id, dataStore)
        .then((response) => {
          fetchUserData();
          toastSuccessMessage(nexSuccessMessage);
          sessionStorage.removeItem("storeData");
          navigate(`/`);
        })
        .catch((error) => {
          if (
            error.response?.status === 400 ||
            error.response?.status === 422
          ) {
            toast.error(
              <div>
                Usługa ekskluzywna {careerName} w wybranym terminie jest już
                niedostępna.
              </div>,
              {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              }
            );

            let storedData = sessionStorage.getItem("storeData");
            let dataObject = JSON.parse(storedData);
            delete dataObject.offer;
            delete dataObject.bookingId;
            setParsedData(dataObject);
            let updatedData = JSON.stringify(dataObject);
            sessionStorage.setItem("storeData", updatedData);
            setCareerName("Żadnej z usług dodatkowych");
            setCalendarDate();
            setCareerIcon();
          }
          console.error(error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  }

  function goBack() {
    navigate(`/${RoutePathConstants.Store}`);
  }

  function goMainPanel() {
    navigate(`/`);
  }

  function orderVoucher() {
    setIsSubmitting(true);

    StoreService.storeItems()
      .then((response) => {
        putNewFundingOrder(response.data.filter((item) => item.type === 1));
      })
      .catch((error) => {
        toast.error("Coś poszło nie tak");
        console.error(error);
        setIsSubmitting(false);
      });
  }

  function putNewFundingOrder(fundingOffer) {
    const dataStore = {
      fundingItemId: fundingOffer[0].id,
    };

    StoreService.updateClientFundingOrder(user.id, dataStore)
      .then((response) => {
        const updatedUser = updateUserCurrentStep(
          user,
          ProcessStatusEnum.CompletingBalanceSheetOfModuleSecond.value,
          null
        );
        setUser(updatedUser);
        sessionStorage.removeItem("storeData");
        toastSuccessMessage(`Ankieta "Twój Cel Rozwojowy" została odblokowana`);
        navigate(`/`);
      })
      .catch((error) => {
        toast.error("Coś poszło nie tak");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  return (
    <>
      <PageHeader content={PageTitleConstants.StoreSummary} />
      <Card className="storeSummary">
        <Card.Body>
          <div className="background_4">
            {isSubmittinginfo || !parsedData ? (
              <Loading size="lg" className="px-10" variant="light" />
            ) : (
              <>
                <WindowOption
                  calendarDate={calendarDate}
                  parsedData={parsedData}
                  fundingName={fundingName}
                  fundingIcon={fundingIcon}
                  careerName={careerName}
                  careerIcon={careerIcon}
                  serviceName={serviceName}
                  serviceIcon={serviceIcon}
                />
                {isSaved ? (
                  <>
                    {user.currentStep ===
                      ProcessStatusEnum.EndWithoutOrder.value && (
                      <>
                        <div className="title-3 pt-4-5">
                          Czy jesteś zainteresowany/a uzyskaniem dofinansowania
                          w formie bonów szkoleniowych i chcesz otrzymać dostęp
                          do formularza zamawiania bonów?
                        </div>
                        <div className="button-box-summary">
                          <button
                            className="button-confirm-2"
                            onClick={orderVoucher}
                          >
                            {isSubmitting ? (
                              <Loading
                                size="sm"
                                className="px-3"
                                variant="light"
                              />
                            ) : (
                              <>Tak, jestem zainteresowany</>
                            )}
                          </button>
                          <button
                            className="button-confirm-2"
                            onClick={goMainPanel}
                          >
                            Wróć do panelu klienta
                          </button>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div className="title-3 pt-4-5">
                      Czy potwierdzasz swoją decyzję?
                    </div>
                    <div className="button-box-summary">
                      <button
                        className="button-confirm-2"
                        disabled={isSubmitting}
                        onClick={goSubmit}
                      >
                        {isSubmitting ? (
                          <Loading size="sm" className="px-3" variant="light" />
                        ) : (
                          <>Tak, potwierdzam</>
                        )}
                      </button>

                      <button className="button-confirm-2" onClick={goBack}>
                        Nie, chcę zmienić wybór
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default StoreSummary;
